var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpandTool = function SvgExpandTool(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-4 -4 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6242 8.5C10.3726 8.5 10.2328 8.20902 10.3899 8.01259L11.7657 6.29283C11.8858 6.1427 12.1142 6.1427 12.2343 6.29283L13.6101 8.01259C13.7672 8.20902 13.6274 8.5 13.3758 8.5H10.6242Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7072 11.7657C19.8573 11.8858 19.8573 12.1142 19.7072 12.2343L17.9874 13.6101C17.791 13.7672 17.5 13.6274 17.5 13.3758V10.6242C17.5 10.3726 17.791 10.2328 17.9874 10.3899L19.7072 11.7657Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29283 12.2343C4.1427 12.1142 4.1427 11.8858 4.29283 11.7657L6.01259 10.3899C6.20902 10.2328 6.5 10.3726 6.5 10.6242V13.3758C6.5 13.6274 6.20902 13.7672 6.01259 13.6101L4.29283 12.2343Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2343 17.7072C12.1142 17.8573 11.8858 17.8573 11.7657 17.7072L10.3899 15.9874C10.2328 15.791 10.3726 15.5 10.6242 15.5H13.3758C13.6274 15.5 13.7672 15.791 13.6101 15.9874L12.2343 17.7072Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H21C22.1 3 23 3.9 23 5V19C23 20.1 22.1 21 21 21H3C1.9 21 1 20.1 1 19V5C1 3.9 1.9 3 3 3ZM21 5H3V19H21V5Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpandTool);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "expand-tool.029b0e44981b118f7a5c419c0a858ae7.svg";